import React from "react";
import clsx from "clsx";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
    },
    form: {
      width: "100%",
      // padding: '2px 4px',
      alignItems: "center",
    },
    paper: {
      display: "flex",
      height: "24px",
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
      fontSize: "0.8rem",
    },
    iconButtonOn: {
      padding: "4px 10px",
      fontSize: "0.8rem",
    },
    iconButtonOff: {
      color: "rgba(0,0,0,0.22)",
      padding: "4px 10px",
      fontSize: "0.8rem",
    },
  })
);

interface Props {
  toolTipTitle: string;
  initialText: string;
  handleChange: (text: string) => void;
  square?: boolean;
  className?: string;
}

/** 仮想フォルダ用フィルタ入力ボックス */
export function VirtualFolderFilterInput(props: Props) {
  const classes = useStyles();

  const { toolTipTitle, initialText, square, className } = props;

  // States
  // 入力中のキーワード
  const [inputText, setInputText] = React.useState<string>(initialText);

  // handlers
  const { handleChange } = props;

  /** キーワード変更ハンドラ */
  const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputText(event.target.value);
  };
  /** サブミットハンドラ */
  const handleOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault(); // サブミットを止める
    handleChange(inputText);
  };
  /** フィルタアイコンクリックハンドラ   */
  const handleOnClick = () => {
    handleChange(inputText);
  };

  //--------------------
  // コンポーネント
  return (
    <div className={clsx(classes.container, className)}>
      <form className={classes.form} noValidate onSubmit={handleOnSubmit}>
        <Paper square={square} className={classes.paper}>
          <InputBase
            type="text"
            name="text"
            className={classes.input}
            placeholder=""
            inputProps={{ "aria-label": "" }}
            onChange={handleOnChange}
            value={inputText}
          />
          <Tooltip title={toolTipTitle} aria-label="filter-keywords">
            <IconButton
              type="submit"
              size="small"
              className={
                initialText ? classes.iconButtonOn : classes.iconButtonOff
              }
              aria-label="search"
              onClick={handleOnClick}
            >
              <FontAwesomeIcon icon={faFilter} />
            </IconButton>
          </Tooltip>
        </Paper>
      </form>
    </div>
  );
}
